var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3GroundHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 38a27 27 0 11-54 0h4a23 23 0 0046 0h4zM38 48.5a8 8 0 008-8c0-5.36-6.5-10.86-8-17-1.5 6.14-8 11.64-8 17a8 8 0 008 8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Ground_humidity.d9eab2aa.svg";
export { SvgB3GroundHumidity as ReactComponent };